import styled from 'styled-components';
import {
  BRIGHT_GRAY,
  BOMBAY,
  WHITE,
  CORNFLOWER_BLUE,
  LINK_WATER,
  PORCELAIN, PUNCH,
} from 'constants/colors';

export const MENU_BAR_HEIGHT = (isMobile = false) => (isMobile ? '2rem' : '3.5rem');

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${BRIGHT_GRAY};
  height: ${({ isMobile }) => MENU_BAR_HEIGHT(isMobile)};
  z-index: 100;
`;
export const AppDrawer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 1.5rem 0 0.8rem;
  box-sizing: border-box;
  overflow: hidden;
  > svg {
    color: ${BOMBAY};
    margin-right: 1rem;
    max-width: 1.5rem;
    max-height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
  }
  > h3 {
    color: ${WHITE};
    font-weight: bold;
    font-size: 0.8rem;
    user-select: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    @media (min-width: 768px) {
      font-size: 1.1rem;
    }
  }

  &:hover {
    cursor: pointer;
    > svg {
      color: ${WHITE}; 
    }
  }

  ${({ isActive }) =>
    isActive &&
    `
    > svg {
      color: ${WHITE}; 
    }
  `}
  button.help-button {
    font-weight: 700;
    color: ${WHITE};
    background: #565656;
    border: none;
    border-radius: 4px;
    margin-left: -14px;
    margin-right: -13px;
    font-size: 11px;
    cursor: pointer;
    padding: 8px 16px;
  }

  button.help-button.active {
    background: #b72d53;
  }

  button.help-button:hover {
    background: #565656;
  }

  button.help-button.active:hover {
    background: #b72d53;
  }
`;

export const LogoWrap = styled.div`
  display: flex;
  width: 33%;
  margin: 0 0.5%;
  height: 100%;
  justify-content: center;
  > svg {
    width: 100%;
    max-width: 8rem;
    height: 100%;
    padding: 10px 0;
    @media (min-width: 768px) {
      max-width: 12rem;
    }
  }
`;
export const LeftContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 33%;
  height: 100%;
`;
export const RightContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 33%;
  height: 100%;
  margin-left: auto;
`;
export const RightNavColumn = styled.div`
  padding: 0 0.5rem 0 0.5rem;
  user-select: none;
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
`;

export const NavBarImageButton = styled.button`
  height: 100%;
  font-size: 0.875rem;
  font-weight: bold;
  color: ${BOMBAY};
  background: none;
  &:hover {
    color: ${WHITE};
  }
`;

export const SupportButton = styled.button`
    position: relative;
    
  .badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: ${PUNCH};
    color: white;
    border-radius: 50%;
    padding: 2px 6px;
    font-size: 12px;
    font-weight: bold;
    min-width: 20px;
    text-align: center;
    line-height: 1;
      height: 20px;
  }
`;

export const MenuLinkWrap = styled.div`
  width: 100%;
  a, button {
    display: flex;
    width: 100%;
    text-align: left;
    box-sizing: border-box;
    color: ${CORNFLOWER_BLUE};
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
    align-items: center;
    &:hover {
      background-color: ${LINK_WATER};
    }
    ${({ disabled }) =>
      disabled &&
      `
      color: ${BOMBAY};
      background-color: ${PORCELAIN};
      opacity: 0.7;
      &:hover {
        background-color: ${PORCELAIN};
        cursor: not-allowed;
      }
    `}
    > * {
      &:first-child {
        margin-right: 0.5rem;
      }
    }
  } 
`;

export const AccountMenuContent = styled.div`
  padding: 1rem 0;
  min-width: 15rem;
`;
